export const ezio_darkest_grey = "#313131";
export const ezio_dark_grey = "#4A4A4A";
export const ezio_medium_grey = "#74787D";
export const ezio_medium_light_grey = "#F5F5F5";
export const ezio_light_grey = "#F5F5F5";
export const ezio_dark_green = "#035E5B"; // "rgba(3, 94, 91, 0.8)";
export const ezio_grey_green = "#8eb7b5"; // rgb(142,183,181);